<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <div class="title dialog-title">
                {{ 'workflows.screens.contractCreator.toolbarTitle' | translate:{ name: person?.fullName || company?.fullName } }}
            </div>
            <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>


    <div [formGroup]="formGroup" mat-dialog-content fusePerfectScrollbar>

            <div>
                <h2>{{ 'workflows.screens.contractCreator.sectionTemplatesTitle' | translate }}</h2>
                <p>
                    {{ 'workflows.screens.contractCreator.sectionTemplatesIntro' | translate:{ relations: (person || company)?.activeAndNextTenantRelationAssignmentNames } }}
                </p>
            </div>

            <div class="mb-24" fxLayout="column">
                <div fxFlex="100">
                    <app-input-auto-complete formControlName="contract"
                                             [list]="availableContracts"
                                             [displayWith]="'title'"
                                             [filterBy]="['title']"
                                             [groupByOrder]="contractAutocompleteGroupOrder"
                                             [groupBy]="'group'"
                                             [isLoadingList]="loadingContracts"></app-input-auto-complete>
                </div>
            </div>

            <ng-container
                    *ngIf="selectedContract && (missingFields.person?.length || missingFields.company?.length || missingFields.tenant?.length || missingFields.berth?.length || missingFields.boat?.length)">
                <div class="mb-24">
                    <u2b-message type="warning" [collapsable]="true">
                        <header>{{ 'workflows.screens.contractCreator.missingDataHeader' | translate }}</header>
                        <p>
                            {{ 'workflows.screens.contractCreator.missingDataIntro' | translate }}
                        </p>
                        <ng-container *ngIf="missingFields.tenant?.length">
                            <p>
                                <strong>{{ 'workflows.screens.contractCreator.missingTenantTitle' | translate }}</strong>
                            </p>
                            <ul>
                                <li *ngFor="let item of missingFields.tenant">{{ item }}</li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="person && missingFields.person?.length">
                            <p>
                                <strong>{{ 'workflows.screens.contractCreator.missingPersonTitle' | translate }}</strong>
                            </p>
                            <ul>
                                <li *ngFor="let item of missingFields.person">{{ item }}</li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="company && missingFields.company?.length">
                            <p>
                                <strong>{{ 'workflows.screens.contractCreator.missingCompanyTitle' | translate }}</strong>
                            </p>
                            <ul>
                                <li *ngFor="let item of missingFields.company">{{ item }}</li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="missingFields.boat?.length">
                            <p>
                                <strong>{{ 'workflows.screens.contractCreator.missingBoatTitle' | translate }}</strong>
                            </p>
                            <ul>
                                <li *ngFor="let item of missingFields.boat">{{ item }}</li>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="missingFields.berth?.length">
                            <p>
                                <strong>{{ 'workflows.screens.contractCreator.missingBerthTitle' | translate }}</strong>
                            </p>
                            <ul>
                                <li *ngFor="let item of missingFields.berth">{{ item }}</li>
                            </ul>
                        </ng-container>
                    </u2b-message>
                </div>
            </ng-container>

            <form-widget-date-range [parentFormGroup]="formGroup"
                                    [headline]="'workflows.formWidgets.dateRange.defaultHeadline' | translate"
                                    [from]="bookingFromDate"
                                    [to]="bookingToDate"></form-widget-date-range>

            <ng-container *ngIf="hasBoat">
                <mat-divider class="special-divider"></mat-divider>

                <ng-container *ngIf="!availableBoats?.length">
                    <div>
                        <u2b-message type="warning">
                            <span [innerHtml]="('workflows.screens.contractCreator.personOrCompanyHasNoBoat' | translate : {name: (person?.fullName || company?.fullName)})"></span>
                        </u2b-message>
                    </div>
                </ng-container>

                <ng-container *ngIf="availableBoats?.length > 1">
                    <div>
                        <h2>{{ 'workflows.screens.selectBoat.title' | translate }}</h2>
                    </div>

                    <div>
                        <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                            <mat-label>{{ 'boats.singular' | translate }}</mat-label>
                            <mat-select matInput data-test="FI-Boot" formControlName="boat"
                                        [compareWith]="compareBoats">
                                <mat-option *ngFor="let boat of availableBoats"
                                            [value]="boat">
                                    <bcm-boat-link [disableLink]="true" [boat]="boat"></bcm-boat-link>
                                </mat-option>
                            </mat-select>
                            <mat-error>{{ formGroup.get('boat').errors | firstErrorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>

                <ng-container *ngIf="availableBoats?.length === 1">
                    <div>
                        <h2>{{ 'workflows.screens.contractCreator.usedBoat' | translate }}: <strong>{{ formGroup.get('boat').value.name }}</strong></h2>
                        <u2b-message type="info">
                            <span [innerHtml]="'workflows.screens.contractCreator.personOrCompanyHasBoat' | translate : {name: person?.fullNameBackward || company?.fullName}"></span>
                        </u2b-message>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="hasBerth && availableBerths">
                <mat-divider class="special-divider"></mat-divider>

                <ng-container *ngIf="formGroup.get('boat').value && !availableBerths?.length">
                    <div>
                        <u2b-message type="warning">
                            <p [innerHtml]="'workflows.screens.contractCreator.boatHasNoBerthAssignment' | translate"></p>
                        </u2b-message>
                    </div>
                </ng-container>

                <ng-container *ngIf="availableBerths?.length > 1">
                    <div>
                        <h2>{{ 'workflows.screens.contractCreator.chooseBerthsTitle' | translate }}</h2>
                        <u2b-message type="info">
                            {{ 'workflows.screens.contractCreator.berthsAutoAssignedInfo' | translate }}
                        </u2b-message>
                    </div>

                    <div>
                        <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                            <mat-label>{{ 'workflows.screens.contractCreator.berthsLabel' | translate }}</mat-label>
                            <mat-select matInput multiple data-test="FI-Liegeplatz" formControlName="berths"
                                        [compareWith]="compareBerth">
                                <mat-option *ngFor="let berth of availableBerths"
                                            [value]="berth">
                                    {{ berth.handle }}
                                    <ng-container *ngIf="berth.pier?.handle">- {{ berth.pier?.handle }}</ng-container>
                                </mat-option>
                            </mat-select>
                            <mat-error>{{ formGroup.get('berths').errors | firstErrorMessage }}</mat-error>
                        </mat-form-field>
                    </div>

                    <u2b-message *ngIf="!selectedBerths.length" type="warning">
                        {{ 'workflows.screens.contractCreator.berthsRequired' | translate }}
                    </u2b-message>
                </ng-container>

                <ng-container *ngIf="selectedBerth && availableBerths?.length === 1">
                    <div>
                        <h2 [innerHTML]="'workflows.screens.contractCreator.usedBerthTitle' | translate:{ handle: selectedBerth.handle }"></h2>
                        <u2b-message type="info">
                            {{ 'workflows.screens.contractCreator.berthAutoAssignedInfo' | translate:{ handle: selectedBerth.handle } }}
                        </u2b-message>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="hasCoOwner">
                <mat-divider class="special-divider"></mat-divider>
                <form-widget-contract-co-owner [parentFormGroup]="formGroup"
                                               [knownShortCodeList]="knownShortCodeList"></form-widget-contract-co-owner>
            </ng-container>

            <ng-container *ngIf="hasBkz">
                <mat-divider class="special-divider"></mat-divider>
                <form-widget-building-cost-subsidy [parentFormGroup]="formGroup"
                                                   [knownShortCodeList]="knownShortCodeList"></form-widget-building-cost-subsidy>
            </ng-container>

            <ng-container *ngIf="hasProducts">
                <mat-divider class="special-divider"></mat-divider>
                <form-widget-product-list [parentFormGroup]="formGroup"
                                          [enableDynamicPrice]="true"
                                          [dynamicPriceContext]="dynamicPriceContext"
                                          [berthAssignments]="berthAssignments"
                                          [defaultBerthReservationTimeUnit]="defaultBerthReservationTimeUnit"
                                          (dynamicPriceErrorChanged)="productDynamicPriceHasError = $event"></form-widget-product-list>
            </ng-container>

            <ng-container *ngIf="hasKey">
                <mat-divider class="special-divider"></mat-divider>
                <ng-container *ngIf="person && !person.keys?.length">
                    <u2b-message type="warning">
                        <p>
                            {{ 'workflows.screens.contractCreator.keyPlaceholderMissing' | translate:{ name: person?.fullName } }}
                        </p>
                    </u2b-message>
                </ng-container>

                <ng-container *ngIf="person && person.keys?.length">
                    <div>
                        <h2>{{ 'workflows.screens.contractCreator.chooseKeyTitle' | translate }}</h2>
                    </div>

                    <div>
                        <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                            <mat-label>{{ 'workflows.screens.contractCreator.keyLabel' | translate }}</mat-label>
                            <mat-select matInput data-test="FI-Boot" formControlName="key"
                                        [compareWith]="compareKeys">
                                <mat-option *ngFor="let key of person.keys"
                                            [value]="key">
                                    <bcm-key-link [key]="key.key" [disableLink]="true"></bcm-key-link>
                                    ({{ 'workflows.screens.contractCreator.keyOptionNumber' | translate:{ number: key.keyNumber } }})
                                </mat-option>
                            </mat-select>
                            <mat-error>{{ formGroup.get('key').errors | firstErrorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="unknownShortCodeList?.length && unknownShortCodeForm">

                <mat-divider class="special-divider"></mat-divider>

                <div>
                    <h2>{{ 'workflows.screens.contractCreator.unknownPlaceholdersTitle' | translate }}</h2>
                </div>

                <ng-container *ngFor="let unknownShortCode of unknownShortCodeList">
                    <div [formGroup]="unknownShortCodeForm">
                        <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                            <mat-label>{{ unknownShortCode }}</mat-label>
                            <input matInput data-test="FI-Boot"
                                   [formControlName]="unknownShortCode">
                        </mat-form-field>
                    </div>
                </ng-container>

            </ng-container>

            <mat-divider class="special-divider"></mat-divider>

            <div class="mb-24" fxLayout="column">

                <ng-template #noMail>
                    <u2b-message>
                        <header>{{ 'workflows.screens.contractCreator.noEmailHeader' | translate }}</header>
                        {{ 'workflows.screens.contractCreator.noEmailBody' | translate:{ name: (person || company).fullName } }}
                    </u2b-message>
                </ng-template>

                <ng-container *ngIf="contractTemplateMissing">
                    <u2b-message type="error">{{ 'workflows.formWidgets.contract.wordDocumentMissing' | translate }}</u2b-message>
                </ng-container>

                <ng-container *ngIf="(person || company).mail; else noMail">
                    <p>
                        <mat-checkbox formControlName="sendMail"
                                      [disabled]="contractTemplateMissing">
                            <span [innerHTML]="'workflows.screens.contractCreator.sendMailCheckbox' | translate:{ mail: (person || company).mail }"></span>
                        </mat-checkbox>
                    </p>
                </ng-container>

                <p>
                    <mat-checkbox formControlName="downloadPdf"
                                  [disabled]="contractTemplateMissing">
                        {{ 'workflows.screens.contractCreator.downloadPdfCheckbox' | translate }}
                    </mat-checkbox>
                </p>

                <ng-container
                        *ngIf="selectedContract?.isWordTemplate && selectedContract.hasDifferentTemplates && !formGroup.get('sendMail').value">
                    <p>
                        <mat-radio-group class="contract-file-type-rg" fxFlex="100" fxLayout="row"
                                         formControlName="contractFileType">
                            <mat-radio-button [disabled]="!selectedContract?.templateMailFile"
                                              fxFlex="100" [value]="ContractFileType.MAIL">
                                {{ 'workflows.formWidgets.contract.radioMailTemplate' | translate }}
                            </mat-radio-button>
                            <mat-radio-button [disabled]="!selectedContract?.templatePrintFile"
                                              fxFlex="100" [value]="ContractFileType.PRINT">
                                {{ 'workflows.formWidgets.contract.radioPrintTemplate' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </p>
                </ng-container>

            </div>

            <mat-divider class="special-divider"></mat-divider>

            <form-widget-signature [parentFormGroup]="formGroup"
                                   [conditionCheckboxLabel]="'workflows.formWidgets.signature.contractSignNowCheckbox' | translate"></form-widget-signature>

    </div>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
            {{ 'common.cancel' | translate }}
        </button>

        <div>

            <ng-template #saving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.saving' | translate }}</span>
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-template>

            <ng-template #notSaving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.save' | translate }}</span>
            </ng-template>

            <button (click)="onClickSaveAndClose(true)" data-test="B-Vorschau"
                    mat-flat-button color="accent"
                    [disabled]="isContractActionDisabled">
                {{ 'workflows.screens.contractCreator.preview' | translate }}
            </button>

            <button (click)="onClickSaveAndClose()" data-test="B-Speichern"
                    mat-flat-button color="accent"
                    [disabled]="isContractActionDisabled">
                <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
            </button>

        </div>

    </div>

</div>
